module.exports = __webpack_public_path__ + "img/logo.5cb9adb3.png";